import { api } from '@creditsights/api-ui-web';
import { Document } from './getSessions.service';

export interface GetAnswerRequest {
  seqId: number;
  query: string;
  sessionId: string;
}

export interface QuestionAnswer {
  answer: string;
  query: string;
  seq_id: number;
  source_documents?: Document[];
}

export const getAnswer = async (request: GetAnswerRequest): Promise<QuestionAnswer> => {
  const { data } = await api.get('/cs-genie/v1/answer/', {
    timeout: 180000,
    params: {
      seq_id: request.seqId,
      query: request.query,
      sessionId: request.sessionId,
    },
  });
  return data;
};
